<template>
  <div>
    <form @submit.prevent="save">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Merge Products Products</p>
        </header>
        <section class="modal-card-body">
          <div class="mb-lg">
            <b-message v-if="generalError" type="is-danger" class="is-size-7">
              {{ generalError }}
            </b-message>
            <b-message v-else type="is-info" class="is-size-7">
              These selected products will be merged into a new proposal.
              Are you sure you want to merge <b>{{ this.proposals.length }}</b> {{ (this.proposals.length == 1) ?
                "product" : "products" }} into a separate proposal?
            </b-message>
          </div>
          <div class="mb-lg">
            <p class="has-text-weight-bold mb-sm">Behavior</p>
            <b-field><b-radio v-model="method" native-value="new">Add products to a <b>new</b>
                proposal</b-radio></b-field>
            <!-- <b-field><b-radio v-model="method" native-value="existing">Add products to an <b>existing</b> proposal</b-radio></b-field> -->
          </div>
          <div v-if="method === 'new'" class="mb-lg">
            <!-- New Proposal Name -->
            <b-field label="New Proposal Name" :type="('name' in errors) ? 'is-danger' : ''"
              :message="('name' in errors) ? errors['name'][0] : ''" expanded>
              <b-input type="text" v-model="name" placeholder="Enter new proposal name..." size="is-medium"></b-input>
            </b-field>
          </div>
        </section>
        <footer class="modal-card-foot space-between">
          <b-button @click="$parent.close()">Close</b-button>
          <b-button type="is-primary" native-type="submit" :loading="saving" :disabled="saving">
            Merge Products
          </b-button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['context'])
  },
  data () {
    return {
      users: [],
      method: 'new',
      name: null,
      saving: false,
      errors: {},
      generalError: null
    }
  },
  methods: {
    save () {
      this.saving = true
      const endpoint = this.context.route + '/proposals/merge/'
      const query = { id: this.$utils.map(this.proposals, 'id').join(',') }
      const body = {
        name: this.name
      }
      this.$http.post(endpoint, body, { params: query }).then(response => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Proposals merged!' })
        this.$parent.close()
        this.$emit('reload')
      }).catch(() => {
        this.generalError = 'These products cannot be merged (likely because of the status of the proposal).'
      }).finally(() => {
        this.saving = false
      })
    }
  },
  mounted () {
  },
  props: {
    proposals: {
      type: Array,
      required: true
    }
  }
}
</script>
